<template>
    <div>        
        <entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>        
    </div>
</template>

<script>
    import CompanyArticle from "@/models/companyArticle.model.vue";
    import EntityCard from "@/components/Espresso/EntityCard.vue";
    import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
    import { Tabs, Modal } from "@/components";

    export default {
        components: {
            EntityCard,
            PaginatedSearch,
            Tabs,
            Modal
        },
        data() {
            return {
                entity: {
                    id: this.$route.params.companyArticleId,
                    companyId: this.$route.params.id,                    
                },
                schema: CompanyArticle.getSchema(),
                showModal: false,
            }
        },
        methods: {
            async createEntity(entity) {
				this.entity = await CompanyArticle.create(entity);
				this.$router.replace(`/empresa/${this.entity.companyId}/teste/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				const response = await CompanyArticle.getInfo(entityId);
				return response;
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return CompanyArticle.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await CompanyArticle.remove(entityId);
				//this.$router.push("/empresas");
                this.$router.go(-1);
			},
        },
        mounted() {
            console.log("Teste mounted");
        }
    }

</script>

<style>
.tab-pane-1,
.tab-pane-2 {
  width: 100% !important;
}

.modal-container {
	box-shadow: none !important;
}
</style>